module.exports = __webpack_public_path__ + "img/file-------------------------------------------------------------1@1x.dda0f54c.png";